import useSWR from "swr"
import { api } from "@lib/orpc-client"

type MappedBenefitsDetails = {
    title: string;
    value: number;
    unit: string;
    unitPosition: 'left' | 'right';
    isCurrency: boolean;
}

type MappedKYCLevelBenefit = {
    isActive: boolean;
    levelName: string;
    benefits: MappedBenefitsDetails[];
};

const useKYCBenefit = () => {
    const { data, isLoading, error } = useSWR(
        'walletV2.kyc.benefits',
        () => api.walletV2.kyc.benefits({}),
        {
            dedupingInterval: 10000 // 10 seconds
        }
    )

    const mappedData: MappedKYCLevelBenefit[] = data?.map((item) => {
        return {
            isActive: item.kycLevelStatus.isActive,
            levelName: item.kycLevel,
            benefits: item.kycBenefitDetail.map((benefit) => {
                return {
                    title: benefit.title,
                    value: benefit.unit === 'binary' ? Boolean(benefit.value) : benefit.value,
                    unit: benefit.unit,
                    unitPosition: benefit.unit === 'Rp' ? 'left' : 'right',
                    isCurrency: benefit.unit === 'Rp'
                }
            })
        }
    }) || []

    return {
        data: mappedData,
        isLoading,
        error
    }
}

export default useKYCBenefit
